import type { z } from 'zod';
import {
  DmConversationMessagesResponseSchema,
  DmConversationSummarySchema,
  DmConversationsResponseSchema,
  DmMessageSummarySchema,
  DmParticipantSummarySchema,
} from './schemas';

export type DmParticipantSummaryInput = z.input<typeof DmParticipantSummarySchema>;
export type DmParticipantSummaryOutput = z.output<typeof DmParticipantSummarySchema>;

export function serializeDmParticipantSummary(payload: DmParticipantSummaryInput): DmParticipantSummaryOutput {
  return DmParticipantSummarySchema.parse(payload);
}

export type DmConversationSummaryInput = z.input<typeof DmConversationSummarySchema>;
export type DmConversationSummaryOutput = z.output<typeof DmConversationSummarySchema>;

export function serializeDmConversationSummary(payload: DmConversationSummaryInput): DmConversationSummaryOutput {
  return DmConversationSummarySchema.parse(payload);
}

export type DmMessageSummaryInput = z.input<typeof DmMessageSummarySchema>;
export type DmMessageSummaryOutput = z.output<typeof DmMessageSummarySchema>;

export function serializeDmMessageSummary(payload: DmMessageSummaryInput): DmMessageSummaryOutput {
  return DmMessageSummarySchema.parse(payload);
}

export type DmConversationsResponseInput = z.input<typeof DmConversationsResponseSchema>;
export type DmConversationsResponseOutput = z.output<typeof DmConversationsResponseSchema>;

export function serializeDmConversationsResponse(payload: DmConversationsResponseInput): DmConversationsResponseOutput {
  return DmConversationsResponseSchema.parse(payload);
}

export type DmConversationMessagesResponseInput = z.input<typeof DmConversationMessagesResponseSchema>;
export type DmConversationMessagesResponseOutput = z.output<typeof DmConversationMessagesResponseSchema>;

export function serializeDmConversationMessagesResponse(
  payload: DmConversationMessagesResponseInput
): DmConversationMessagesResponseOutput {
  return DmConversationMessagesResponseSchema.parse(payload);
}
